var _ellipse, _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChooseBranch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.0485026,
    cx: 24.5825,
    cy: 24,
    rx: 24.5825,
    ry: 24,
    fill: "#F68220"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_232_18136",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 16,
    width: 15,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4126 16.0005H31.3541V32.3335H17.4126V16.0005Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_232_18136)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3831 17.3615C21.3083 17.3615 18.8065 19.804 18.8065 22.8059C18.8065 26.4904 23.0607 29.8592 24.3831 30.8167C25.7054 29.8592 29.9597 26.4904 29.9597 22.8059C29.9597 19.804 27.4579 17.3615 24.3831 17.3615ZM24.3833 32.3335C24.2488 32.3335 24.1136 32.296 23.9965 32.2198C23.7281 32.0449 17.4126 27.8758 17.4126 22.8057C17.4126 19.0531 20.5397 16.0001 24.3833 16.0001C28.227 16.0001 31.3541 19.0531 31.3541 22.8057C31.3541 27.8758 25.0386 32.0449 24.7702 32.2198C24.6531 32.296 24.5179 32.3335 24.3833 32.3335Z",
    fill: "#F68220"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3828 21.4448C23.6139 21.4448 22.9886 22.0553 22.9886 22.8059C22.9886 23.5566 23.6139 24.167 24.3828 24.167C25.1516 24.167 25.7769 23.5566 25.7769 22.8059C25.7769 22.0553 25.1516 21.4448 24.3828 21.4448ZM24.3825 25.5279C22.8448 25.5279 21.5942 24.307 21.5942 22.8057C21.5942 21.3044 22.8448 20.0835 24.3825 20.0835C25.9203 20.0835 27.1708 21.3044 27.1708 22.8057C27.1708 24.307 25.9203 25.5279 24.3825 25.5279Z",
    fill: "#F68220"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseBranch);
export default __webpack_public_path__ + "static/media/choose-branch.cbde97491eb7b7968d652cb96a5d44cc.svg";
export { ForwardRef as ReactComponent };